import { getCsrfValue } from "~/common/utils/ApiHelper";
import { CAPTCHA_SITE_KEY_FIELD } from "~/utils/constants";
import { resolveApiUrl } from "~/utils/url/urlResolver";

export interface ResponseData {
  globalErrors: string[];
  validationResults: { [fieldName: string]: string[] };
}

const apiUrl = resolveApiUrl("/login/pw/request");

export function sendResetPasswordRequest(email: string, captchaValue: string): Promise<ResponseData> {
  const params = new URLSearchParams();
  params.set("email", email);
  params.set(CAPTCHA_SITE_KEY_FIELD, captchaValue);

  return fetch(apiUrl, {
    body: params.toString(),
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/x-www-form-urlencoded",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`Error resetting password. Code: ${response.status}`);
    }
    return response.json() as Promise<ResponseData>;
  });
}
